<template>
  <div id="userDetail" v-if="divVisible">
    <b>ユーザー情報管理画面</b><br/><br/>

    <table>
      <tr>
        <td>ユーザー情報を管理いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <tbody>
            <tr>
              <td><b>ユーザーID：</b></td>
              <td><input type="text" style="width: 40%;"  v-bind:disabled="$route.params.operationType != 'create'" v-model="rows[0].memberID"></td>
            </tr>
            <tr>
              <td><b>ユーザー名：</b></td>
              <td><input type="text" style="width: 100%;" v-bind:disabled="$route.params.operationType != 'create'" maxlength="1024" v-model="rows[0].memberName"></td>
            </tr>
            <tr>
              <td><b>ユーザータイプ：</b></td>
              <td><select  v-bind:disabled="$route.params.operationType == 'delete'" v-model="rows[0].userType">
                  <option value="1">システム管理者</option>
                  <option value="3">管理者</option>
                  <option value="5">リーダー</option>
                  <option value="7">一般</option>
                  <option value="8">スタッフ</option>
                  <option value="9">派遣社員</option>
                </select>
              </td>
            </tr>
            <tr>
              <td><b>アカウント状態：</b></td>
              <td><select  v-bind:disabled="$route.params.operationType == 'delete'" v-model="rows[0].deleteFlg">
                  <option value="0">普通</option>
                  <option value="1">使用不可</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="$route.params.operationType == 'delete'">削除</button>&nbsp;
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="$route.params.operationType == 'modify'">変更</button>&nbsp;
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="$route.params.operationType == 'create'">新規</button>&nbsp;
      <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "projectManage",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          // heads: [ ],
          rows:  null,
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/userDetailInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                // self.heads = res.data.heads;
                self.rows = res.data.rows;
 
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      processClick: function () {
        var self = this;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        $("#saveBtn").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/userDetailSave", data)
          .then(function (res) {
            $("#saveBtn").attr("disabled", false);
            // 処理正常の場合
            if (res.data == '') {
              self.$router.push({ name: 'userManage', params: { } });
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }
          })
          .catch(function (err) {
            $("#saveBtn").attr("disabled", false);
            alert(err);
          });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// userDetail.vue?685a2692